/**
 * Control Login Class
 */
window.ControlLogin =
{
    /**
     * Selectors
     *
     */
    selectors:
    {
        loginContainer:             document.querySelector('.login-container'),
        loginPanelContainer:        document.querySelector('.login-panel-container'),
        forgotPasswordContent:      document.querySelector('.forgot-password-content'),
        forgotPasswordModel:        document.querySelector('.forgot-password'),
        closeForgotPasswordModel:   document.querySelector('.close-forgotpassword'),
        btnForgotPassword:          document.getElementById('btn-forgot-password'),
        errorList:                  document.getElementById('error-list'),
        errorListContainer:         document.getElementById('error-message-container'),
        successListContainer:       document.getElementById('success-message-container'),
        successMessage:             document.getElementById('success-message')
    },

    /**
     * Init Function
     *
     */
    init: function()
    {
        this.addHandlers();
    },

    /**
     * Add Handlers
     *
     */
    addHandlers: function()
    {
        var context = this;

        this.toggleLogin();

        this.selectors.btnForgotPassword.onclick = function(e)
        {
            e.preventDefault();
            context.postForgotPasswordForm();
        };
    },

    /**
     * Toggle Login
     *
     */
    toggleLogin: function()
    {
        var context = this;

        this.selectors.forgotPasswordModel.onclick = function()
        {
            context.resetMessageContainer();
            context.selectors.closeForgotPasswordModel.classList.add('active');
            context.selectors.forgotPasswordContent.classList.add('active');
        };

        this.selectors.closeForgotPasswordModel.onclick = function()
        {
            context.resetMessageContainer();
            if(context.selectors.forgotPasswordContent.classList.contains('active'))
            {
                context.selectors.forgotPasswordContent.classList.remove('active');
            }
            context.selectors.closeForgotPasswordModel.classList.remove('active');
        }
    },

    /**
     * Post Forgot Password Form
     *
     */
    postForgotPasswordForm: function()
    {
        var context     = this,
            formData    = new FormData(jQuery("#forgot-password-from")[0]);

        this.resetMessageContainer();

        jQuery.ajax(
            {
                url:            moduleConfig.postForgotPasswordForm,
                type:           'POST',
                data:           formData,
                contentType:    false,
                processData:    false,
                dataType:       'JSON',
                success: function(data)
                {
                    if(data.success)
                    {
                        context.showSuccessMessages(data);
                    }
                },
                error: function(data)
                {
                    context.showErrorMessages(data.responseJSON);
                }
            });
    },

    /**
     * Reset Message Container
     *
     */
    resetMessageContainer: function()
    {
        this.selectors.errorListContainer.classList.add('hide');
        this.selectors.errorList.innerHTML = '';

        this.selectors.successListContainer.classList.add('hide');
        this.selectors.successMessage.innerHTML = '';
    },

    /**
     * Show Error Messages
     *
     * @param errors
     */
    showErrorMessages: function(errors)
    {
        var errorListItem;

        if(errors && errors.status === false)
        {
            if(errors.messages)
            {
                for(var i in errors.messages)
                {
                    if(errors.messages.hasOwnProperty(i))
                    {
                        errorListItem           = document.createElement('li');
                        errorListItem.innerHTML = errors.messages[i];
                    }
                }
            }
            else
            {
                errorListItem           = document.createElement('li');
                errorListItem.innerHTML = 'Something went wrong while processing your request.';
            }

            this.selectors.errorList.appendChild(errorListItem);
        }

        this.selectors.errorListContainer.classList.remove('hide');
    },

    /**
     * Show Success Messages
     *
     */
    showSuccessMessages: function(data)
    {
        this.selectors.successMessage.innerHTML = data.message;
        this.selectors.successListContainer.classList.remove('hide');
    }

};


// WEBPACK FOOTER //
// ./resources/js/loyalty/login.js